import { render, staticRenderFns } from "./messageDetailDialog.vue?vue&type=template&id=03405e40&scoped=true&"
import script from "./messageDetailDialog.vue?vue&type=script&lang=js&"
export * from "./messageDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./messageDetailDialog.vue?vue&type=style&index=0&id=03405e40&prod&lang=scss&scoped=true&"
import style1 from "./messageDetailDialog.vue?vue&type=style&index=1&id=03405e40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03405e40",
  null
  
)

export default component.exports